module.exports = __webpack_public_path__ + "media/icons/profile@3x-f36b167a.png";